// frontend/src/components/Navigation/Navigation.js
// Purpose: Provide navigation between different sections of the application
// Desired outcome: Create a responsive navigation bar that shows Upload, Analysis, and Chat sections

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <div className="nav-logo">
          <NavLink to="/upload" onClick={closeMenu}>DART</NavLink>
        </div>

        <button
          className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
          <li>
            <NavLink
              to="/upload"
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
              Upload Files
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/analysis"
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
              Analysis
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/chat"
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeMenu}
            >
              Chat
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
